export default __webpack_public_path__ + "media/images/portfolio/width-600/portfolio-6-bfffb2e8dc03bf3791661184d427da7b.jpg";